import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=0c0d687e&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=0c0d687e&prod&scoped=true&lang=css"
import style1 from "./BankDetails.vue?vue&type=style&index=1&id=0c0d687e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d687e",
  null
  
)

export default component.exports